import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import AvatarFaadi from '../../../assets/avatars/AvatarFaadi.png';

const useStyles = makeStyles({
  peopleContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  infos: {
    marginTop: 10,
    marginLeft: 5
  },
  linkedin: {
    fontSize: 12,
    color: '#002380',
    textDecoration: 'underline'
  },
  name: {
    marginTop: 10,
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  status: {
    marginBottom: 12,
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#A7AAAE'
  }
});

const Guest = () => {
  const classes = useStyles();
  return (
    <div className={classes.peopleContainer}>
      <Avatar className={classes.avatar} src={AvatarFaadi} />
      <div className={classes.infos}>
        <Typography className={classes.name} component="h2" variant="h5">
          Faadi Al Rahman
        </Typography>
        <Typography className={classes.status}>
          Investor (BlackRock)
          <br />
          <a className={classes.linkedin} href="!#">
            see Linkedin profile
          </a>
        </Typography>
      </div>
    </div>
  );
};

export default Guest;
